import React, { useEffect } from 'react'
import WithHOC from './actions'
import { Avatar, Card, Descriptions, Typography, Form, Row, Col, Input, Select, Button, Space, Table, Switch, Modal } from 'antd'
import LoadingOverlay from 'components/LoadingOverlay'
import { Container } from 'react-bootstrap'
import { getItem } from 'utils/tokenStore'
import { UserOutlined, DeleteTwoTone, PlayCircleOutlined } from '@ant-design/icons'
import { ALERT_SOUND_OPTIONS, getSoundSrc } from 'utils/soundLibrary'
import { requestError } from 'utils/requestHandler'
import { useTranslation } from 'react-i18next'


const Profile = props => {

	const { t } = useTranslation();
	const { Title } = Typography
	const [alertSoundForm] = Form.useForm();

	useEffect(() => {
		if (getItem("LOGIN_TOKEN")){
			props.getProfile()
			props.getAlertSoundRules()
		}
		// props.getGames()
		// console.log(props.games)
	}, [])

	const getUserType = (type) => {
    switch (type) {
      case 2:
        return "Superadmin";
      case 1:
        return "Admin";
      case 0:
        return "User";
      default:
        return "Unknown";
    }
  };

	const previewAlertSound = (soundId) => {
		const previewAudio = new Audio(getSoundSrc(soundId));
		previewAudio.play().catch((error) => console.error("Preview playback error:", error));
	}

	const addAlertSoundRule = () => {
		const keyword = alertSoundForm.getFieldValue('keyword')
		const soundId = alertSoundForm.getFieldValue('soundId') || 'classic'
		if (keyword != undefined && keyword.trim().length > 0){
			props.addAlertSoundRule(keyword.trim(), soundId)
			alertSoundForm.resetFields()
		}else{
			requestError("Please fill in required fields!")
		}
	}

	const alertSoundColumns = [
		{
			key: "KEYWORD",
			title: "Keyword",
			dataIndex: "KEYWORD",
		},
		{
			key: "SOUND_ID",
			title: "Sound",
			render: (_, rule) => (
				<Space>
					{ALERT_SOUND_OPTIONS.find(option => option.id === rule.SOUND_ID)?.label || rule.SOUND_ID}
					<PlayCircleOutlined onClick={() => previewAlertSound(rule.SOUND_ID)} />
				</Space>
			),
		},
		{
			key: "ENABLED",
			title: "Enabled",
			render: (_, rule) => (
				<Switch
					checked={rule.ENABLED !== 0}
					onChange={(checked) => props.updateAlertSoundRule(rule.ID, rule.KEYWORD, rule.SOUND_ID, checked)}
				/>
			),
		},
		{
			key: "ACT",
			title: "Action",
			render: (_, rule) => (
				<Space>
					<DeleteTwoTone onClick={() =>
						Modal.confirm({
							title: 'Delete alert sound rule',
							content: 'Are you sure you want to delete this rule?',
							okText: t('Confirm'),
							cancelText: t('Cancel'),
							onOk: () => {
								props.deleteAlertSoundRule(rule.ID);
							},
						})
					}></DeleteTwoTone>
				</Space>
			),
		},
	]

	return (
		<Container>
			<Title>Profile</Title>
			{
				props.onLoading && <LoadingOverlay/>
			}
			{props.profile && <Card
				style={{ maxWidth: 600, margin: "20px auto" }}
				title={
					<div style={{ display: "flex", alignItems: "center" }}>
						<Avatar size={64} icon={<UserOutlined />} style={{ marginRight: 16 }} />
						<span>{props.profile.FULL_NAME}</span>
					</div>
				}
			>
				<Descriptions column={1} bordered>
					<Descriptions.Item label="Email">{props.profile.EMAIL}</Descriptions.Item>
					<Descriptions.Item label="Login Name">{props.profile.LOGIN_NAME}</Descriptions.Item>
					<Descriptions.Item label="Phone">{props.profile.PHONE}</Descriptions.Item>
					<Descriptions.Item label="User Type">{getUserType(props.profile.TYPE)}</Descriptions.Item>
					<Descriptions.Item label="Created At">{props.profile.CREATED}</Descriptions.Item>
					<Descriptions.Item label="Last Updated">{props.profile.LAST_UPDATE}</Descriptions.Item>
				</Descriptions>
			</Card>}

			<Form form={alertSoundForm} layout="vertical">
				<Card
					style={{ maxWidth: 800, margin: "20px auto" }}
					title="My Alert Sound Settings"
				>
					<p>Choose a sound to play when an alert's details contain a keyword you set below (e.g. "FALL").</p>
					<Row gutter={16}>
						<Col span={24} lg={8}>
							<Form.Item
								label="Keyword"
								name="keyword"
								rules={[{ required: true, message: 'Please enter a keyword to match against the alert detail' }]}
							>
								<Input placeholder="e.g. FALL" />
							</Form.Item>
						</Col>
						<Col span={24} lg={8}>
							<Form.Item
								label="Sound"
								name="soundId"
								initialValue="classic"
							>
								<Select options={ALERT_SOUND_OPTIONS.map(option => ({ value: option.id, label: option.label }))} />
							</Form.Item>
						</Col>
						<Col span={24} lg={8} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
							<Space>
								<Button onClick={() => previewAlertSound(alertSoundForm.getFieldValue('soundId') || 'classic')}>
									Preview
								</Button>
								<Button type="primary" size="large" onClick={addAlertSoundRule}>
									Add
								</Button>
							</Space>
						</Col>
					</Row>

					{props.alertSoundRules.length > 0 && (
						<div style={{ display: 'flex', justifyContent: 'center' }}>
							<Table
								dataSource={props.alertSoundRules}
								columns={alertSoundColumns}
								rowKey={"ID"}
								pagination={{
									pageSizeOptions: ['10', '20', '50'],
									showSizeChanger: true,
									defaultPageSize: 10,
									showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
								}}
							/>
						</div>
					)}
				</Card>
			</Form>
		</Container>
	)
}

export default WithHOC(Profile)
